import _defineProperty from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { generateUniqueNumber } from 'fast-unique-numbers';
import { isMessagePort } from './guards/message-port';
import { extendBrokerImplementation } from './helpers/extend-broker-implementation';
/*
 * @todo Explicitly referencing the barrel file seems to be necessary when enabling the
 * isolatedModules compiler option.
 */
export * from './interfaces/index';
export * from './types/index';
var ONGOING_REQUESTS = new WeakMap();
var createOrGetOngoingRequests = function createOrGetOngoingRequests(sender) {
  if (ONGOING_REQUESTS.has(sender)) {
    // @todo TypeScript needs to be convinced that has() works as expected.
    return ONGOING_REQUESTS.get(sender);
  }
  var ongoingRequests = new Map();
  ONGOING_REQUESTS.set(sender, ongoingRequests);
  return ongoingRequests;
};
export var createBroker = function createBroker(brokerImplementation) {
  var fullBrokerImplementation = extendBrokerImplementation(brokerImplementation);
  return function (sender) {
    var ongoingRequests = createOrGetOngoingRequests(sender);
    sender.addEventListener('message', function (_ref) {
      var message = _ref.data;
      var id = message.id;
      if (id !== null && ongoingRequests.has(id)) {
        var _ongoingRequests$get = ongoingRequests.get(id),
          reject = _ongoingRequests$get.reject,
          resolve = _ongoingRequests$get.resolve;
        ongoingRequests.delete(id);
        if (message.error === undefined) {
          resolve(message.result);
        } else {
          reject(new Error(message.error.message));
        }
      }
    });
    if (isMessagePort(sender)) {
      sender.start();
    }
    var call = function call(method) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var transferables = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      return new Promise(function (resolve, reject) {
        var id = generateUniqueNumber(ongoingRequests);
        ongoingRequests.set(id, {
          reject: reject,
          resolve: resolve
        });
        if (params === null) {
          sender.postMessage({
            id: id,
            method: method
          }, transferables);
        } else {
          sender.postMessage({
            id: id,
            method: method,
            params: params
          }, transferables);
        }
      });
    };
    var notify = function notify(method, params) {
      var transferables = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      sender.postMessage({
        id: null,
        method: method,
        params: params
      }, transferables);
    };
    var functions = {};
    for (var _i = 0, _Object$entries = Object.entries(fullBrokerImplementation); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        handler = _Object$entries$_i[1];
      functions = _objectSpread(_objectSpread({}, functions), {}, _defineProperty({}, key, handler({
        call: call,
        notify: notify
      })));
    }
    return _objectSpread({}, functions);
  };
};